import { useState, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { useReadingAccess, useDefinitelyOffline } from '@/lib/reading-access';
import { getOfflineReopenSnapshot, subscribeOfflineReopen } from '@/lib/offline-reopen';
import styles from './ReadingOnlyIndicator.module.css';

export default function ReadingOnlyIndicator() {
  const { t } = useTranslation();
  const { restricted } = useReadingAccess();
  const offline = useDefinitelyOffline();
  const reopen = useSyncExternalStore(subscribeOfflineReopen, getOfflineReopenSnapshot, getOfflineReopenSnapshot);
  const [shown, setShown] = useState(false);
  // Merely waiting for ordinary online verification is not an offline state.
  const visible = restricted && (offline || reopen.phase === 'reading');
  if (visible && !shown) setShown(true);
  // Preserve the already-visible one-line space when the list unlocks; an
  // ordinary online open never creates it or announces a pending state.
  if (!shown) return null;
  return <div className={styles.slot}>
    {visible && <span role="status" className={styles.line}>{t('offlineReopen.readingOnly')}</span>}
  </div>;
}
